<template lang="">
   <v-row>
      <v-col cols="8">
        <v-card 
        class="mx-auto"
    >
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-form
        class="m-5"
    ref="form"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="20"
      label="Nombre de la sucursal"
      required
    ></v-text-field>

    

    <v-btn
      :disabled="!name"
      color="primary"
      class="mr-4"
      @click="subirSucursal" 
      :loading="status"
    >
      Generar
    </v-btn>

     
  </v-form>
        </v-col>
      </v-row>
    </v-container>
        
    </v-card>
      </v-col>
      <v-col cols="4">
         
         <v-card>
             <div v-for="item in sucursal" :key="item.id">
                <v-list-item v-if="item != 'Sin asignacion'">
                  <v-list-item-content>
                      <v-list-item-title>
                        {{item.nombre}}
                        <v-btn @click.prevent="selected(item)" class="mx-2 my-2" fab dark small elevation="3" color="primary">
                          <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn @click.prevent="selectedlocation(item)" class="mx-2 my-2" fab dark small elevation="3" color="secundary">
                          <v-icon dark>mdi-map-marker-multiple</v-icon>
                        </v-btn>
                      </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
             </div>
         </v-card>
       
         
          
      </v-col>
      
        <div class="text-center">















































     <v-overlay light opacity="0.48" z-index="100" :value="edicion">
      <v-card
      light
    class="mx-auto"
    min-width="600"
  >
      <v-btn
        icon
        @click="edicion = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
            
            

    <v-card-subtitle class="pb-0">Edición de sucursal</v-card-subtitle>

    <v-card-text class="text--primary">
      <v-col cols="12" class="d-flex align-content-end">
         <v-col cols="12" class="d-flex align-content-end">
              <v-text-field
                label="Sucursal"
                placeholder="Sucursal"
                outlined
                v-model="select.nombre"
              ></v-text-field>
          </v-col>              
      </v-col>
    </v-card-text>



    <v-card-actions>
       <v-col cols="12">
     <v-btn
       :disabled="false"
        color="primary"
        @click.prevent="editarSucursal"
      >
        Guardar
      </v-btn>

      <v-btn
       :disabled="false"
        color="danger"
        dark
        @click.prevent="dialog = true"
      >
        Eliminar
      </v-btn>

     
        </v-col>
    </v-card-actions>
  </v-card>
    </v-overlay>
   
   
   
   
    <v-overlay light opacity="0.48" z-index="100" :value="location">
      <v-card
      light
    class="mx-auto"
    min-width="600"
  >
      <v-btn
        icon
        @click="location = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
            
            

    <v-card-subtitle class="pb-0">Locaciones de {{select.nombre}} </v-card-subtitle>

  


    <v-card-text>
      <v-col cols="12" class="d-flex justify-center">
         <v-col cols="12" class="">
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Nombre</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="itemms in select.localidad" :key="itemms.id">
                          <td class="text-left">{{ itemms.name }}</td>
                          <td>
                            <v-btn
                              icon
                              @click="selectparadelete(itemms)"
                            >
                              <v-icon dark>mdi-delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>        
          </v-col>  
      </v-col>
    </v-card-text>
    
   
       



    <v-card-actions>
       <v-col cols="12">
     <v-btn
       :disabled="false"
        color="primary"
        @click.prevent="dialog_location_new = true"
      >
        Nueva localidad
      </v-btn>
  </v-col>
    </v-card-actions>
  </v-card>
    </v-overlay>

</div>
  

    <v-dialog
      v-model="dialog_location_new"
      width="500"
      z-index="9999"
    >
    

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Nueva localdidad de ( {{select.nombre}} )
        </v-card-title>

        <v-card-text class="mt-5">
          <v-text-field
                label="Localidad"
                placeholder="Nombre de la nueva localidad"
                outlined
                v-model="nombre_locacion"
              ></v-text-field>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
 
          <v-btn
            color="primary"
            text
            @click="GuardarLocalidad"
          >
            Guardar
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
  
            <v-btn
            color="seccundary"
            text
            @click="dialog_location_new = !dialog_location_new"
          >
            Cancelar
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog
      v-model="dialog"
      width="500"
      z-index="9999"
    >
    

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar ( {{select.nombre}} )
        </v-card-title>

        <v-card-text>
          Estas seguro que quieres Eliminar
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
 
          <v-btn
            color="primary"
            text
            @click="borrarSucursal"
          >
            Si
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
  
            <v-btn
            color="seccundary"
            text
            @click="dialog = !dialog"
          >
            no
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>



  <v-dialog
      v-model="dialog_location_delete"
      width="500"
      z-index="9999"
    >
    

      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Eliminar ( {{selectlocation.name}} )
        </v-card-title>

        <v-card-text>
         ¿ Estas seguro que quieres Eliminar esta localidad ?
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          
 
          <v-btn
            color="primary"
            text
            @click="EliminarLocalidad(selectlocation.id)"
          >
            Si
            <v-icon dark>mdi-delete</v-icon>
          </v-btn>
  
            <v-btn
            color="seccundary"
            text
            @click="dialog_location_delete = !dialog_location_delete"
          >
            no
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>

    


    </v-row>
    
</template>
<script>

import {SubirSucursales, EditSucursal, DeleteSucursal, Subirlocalidad, Deletelocalidad} from '../../../../../../../services/options/sucursales'
import Table from '../../../../../component/helpers/tools/table'

export default {
    
    components:{

        Table

    },

    mounted() {
        
        this.$store.dispatch('GetSucursalAll');
        
    },

    data(){
        return {
            status:false,
            type:'sucursal',
            edicion:false,
            location:false,

            dialog:false,
            dialog_location_new:false,
            dialog_location_delete:false,

            selectlocation:[],


            nombre_locacion:'',


            select:'',
            name:'',
            nameRules: [
                v => !!v || 'Name is required',
                v => (v && v.length <= 20) || 'Name must be less than 10 characters',
            ],

            header: [
                {
                    text: 'Nombre de sucursal',
                    align: 'left',
                    sortable: true,
                    value: 'name',
                },
        ],

         desserts: [
          {
            name: 'Frozen Yogurt',
            calories: 159,
          },
          {
            name: 'Ice cream sandwich',
            calories: 237,
          },
          
         
        ],
       }
    },

    computed: {
        
        sucursal(){
           
           return this.$store.state.sucursalAll
           
        }

    },

    

    methods: {
        

      vaciarcampos:function(){

            this.name = '';
            this.nombre_locacion = '';

        },

        selected:function(item){
          this.edicion = !this.edicion;
          this.select = item;
        },

        selectedlocation:function(item){
          this.location = !this.location;
          this.select = item;
        },

        
        
        subirSucursal:function(){
          this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            SubirSucursales({'name':this.name}).then(response=>{
                this.$router.push({path: '/config/sucursales'});
                this.$store.dispatch('GetSucursalAll');
                this.$store.dispatch('GetSucursal');
                this.$toastr.success('Se ha agregado correctamente la sucursal');
                this.status = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            }).catch(errors=>{
                this.status = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            });
        },


        editarSucursal:function(){

            this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            EditSucursal(this.select.id, {'nombre':this.select.nombre}).then(response=>{
                this.$router.push({path: '/config/sucursales'});
                this.$store.dispatch('GetSucursalAll');
                this.$store.dispatch('GetSucursal');
                this.$toastr.success('Se ha editado correctamente la sucursal');
                this.edicion = false;
                this.status = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            }).catch(errors=>{
                this.status = false;
                 this.edicion = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            });

        },

        borrarSucursal:function(){

            this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            DeleteSucursal(this.select.id).then(response=>{
                this.$router.push({path: '/config/sucursales'});
                this.$store.dispatch('GetSucursalAll');
                this.$store.dispatch('GetSucursal');
                this.$toastr.success('Se ha eliminado correctamente la sucursal');
                this.status = false;
                 this.edicion = false;
                 this.dialog = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            }).catch(errors=>{
                this.status = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                 this.edicion = false;
                 this.dialog = false;
                this.$store.dispatch('LoadingFetchActions', false);
            });
          

        },


        GuardarLocalidad:function(){

          this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            Subirlocalidad({'name':this.nombre_locacion, 'id_sucursal':this.select.id}).then(response=>{
                this.$router.push({path: '/config/sucursales'});
                this.$store.dispatch('GetSucursalAll');
                this.$store.dispatch('GetSucursal');
                this.dialog_location_new = false;
                this.$toastr.success('Se ha agregado una nueva localidad a '+this.select.nombre);
                this.status = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
                setTimeout(()=>{
                  location.reload();
                }, 1000)
                
            }).catch(errors=>{
                this.status = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
            });


        },

        EliminarLocalidad:function(item){
          

          this.$store.dispatch('LoadingFetchActions', true);
            this.status = true;
            Deletelocalidad(item).then(response=>{
                this.$router.push({path: '/config/sucursales'});
                this.$store.dispatch('GetSucursalAll');
                this.$store.dispatch('GetSucursal');
                this.$toastr.success('Se ha eliminado correctamente la sucursal');
                this.status = false;
                this.dialog_location_delete = false;
                 this.edicion = false;
                 this.dialog = false;
                this.vaciarcampos();
                this.$store.dispatch('LoadingFetchActions', false);
                setTimeout(()=>{
                  location.reload();
                }, 1000)
            }).catch(errors=>{
                this.status = false;
                this.$toastr.error(errors)
                this.vaciarcampos();
                 this.edicion = false;
                 this.dialog = false;
                this.$store.dispatch('LoadingFetchActions', false);
            });
        },

        selectparadelete:function(item){

          this.selectlocation = item;
          this.dialog_location_delete = true;
          

        }


    },

}
</script>